<template>
<div v-loading="loading">
  <w-obj-rsc-key-select-component v-show="!hiddenSelectCmp" :rsc-info-list="rscInfoList" @select="setRscInfo" @reset="setRscInfo" />
  <hr v-show="!hiddenSelectCmp" class="mr-t10 mr-b15" />
  <w-threshold-analysis-rslt-component :selectObjThreshold="rscInfo" :isGuideRsltType="false"></w-threshold-analysis-rslt-component>
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import { scatterOptions } from '@/constants/chart-options';
import WObjRscKeySelectComponent from './components/ObjRscKeySelectComponent';
import WThresholdAnalysisRsltComponent from './components/ThresholdAnalysisRsltComponent';

/**
 * 자원 임계치 가이드 화면
 */
export default {
  name: 'WThresholdGuideView',
  components: {
    WObjRscKeySelectComponent,
    WThresholdAnalysisRsltComponent,
  },
  props: {
    rscInfoList: {
      type: Array,
    },
  },
  data() {
    return {
      targetThreshold: null,
      loading: false,
      chartOptions: cloneDeep(scatterOptions),
      targetLabel: null,
      rscInfo: null,
      boundaryData: null,
    };
  },
  computed: {
    hiddenSelectCmp() {
      return this.rscInfoList.length === 1;
    },
  },
  watch: {
    rscInfo: {
      handler(value) {
        if (isEmpty(value)) {
          this.reset();
        }
      },
    },
  },
  methods: {
    isEmpty,
    /**
     * 화면을 초기화한다.
     * @author Ju
     */
    reset() {
      this.loading = false;
      this.chartOptions = cloneDeep(scatterOptions);
    },
    /**
     * 자원 정보를 설정한다.
     * @author Ju
     * @param  {Object} rscInfo 자원 정보 객체
     */
    setRscInfo(rscInfo) {
      const selectRscInfo = rscInfo;
      this.rscInfo = selectRscInfo;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/ResourceSmartAnalyzerPopup/ThresholdGuideView.vue